import apiClient from '../utils/apiClient';

export const AUTH_TOKEN_CHANGE_EVENT = 'FindMeTrek:auth-token-change';

let accessToken = '';

function readFromCookie() {
    try {
        const match = document.cookie.match(/(?:^| )accessToken=([^;]*)/);
        return match ? decodeURIComponent(match[1]) : '';
    } catch {
        return '';
    }
}

export const getAccessToken = () => accessToken || readFromCookie();

export const setAccessToken = (token) => {
    const previousToken = accessToken;
    accessToken = token || '';

    if (accessToken) {
        apiClient.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    } else {
        delete apiClient.defaults.headers.common.Authorization;
    }

    if (previousToken !== accessToken && typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent(AUTH_TOKEN_CHANGE_EVENT, {
            detail: { token: accessToken },
        }));
    }
};

export const clearAccessToken = () => {
    accessToken = '';
    delete apiClient.defaults.headers.common.Authorization;
};

export const getAuthHeaders = (token = getAccessToken()) => (
    token ? { Authorization: `Bearer ${token}` } : {}
);
